import { Box } from "@mui/material";

import { Chip, Skeleton } from "@heroui/react";

import AdvertsCounters from "./AdvertsCounters";
import { Column, Row } from "../../../components/Layout";
import TextLabel from "../../../components/typography/TextLabel";

interface AdvertsSummaryProps {
    total: number
    new: number
    closed: number
    lastUpdated: Date
    loading: boolean
}

export default function AdvertsSummary({ total, new: newCount, closed, lastUpdated, loading }: AdvertsSummaryProps) {

    const now = new Date();
    const diffMilliseconds = now.getTime() - lastUpdated.getTime();

    // Define time units in milliseconds
    const msPerMinute = 60 * 1000;
    const msPerHour = msPerMinute * 60;
    const msPerDay = msPerHour * 24;

    const diffHours = Math.floor(diffMilliseconds / msPerHour);

    function getTimePassedString(): string {

        // Handle dates in the future (optional, based on requirement interpretation)
        if (diffMilliseconds < 0) {
            // Or throw an error, or return a different string like "in X hours"
            return "in the future";
        }

        // Handle very recent times
        if (diffMilliseconds < msPerMinute) {
            return "Just Now"; // Less than a minute ago
        }

        // Check if difference is 24 hours or more
        if (diffHours >= 24) {
            const diffDays = Math.floor(diffMilliseconds / msPerDay);
            // Handle singular vs. plural "day(s)"
            return `${diffDays} Day${diffDays === 1 ? '' : 's'} Ago`;
        } else {
            // Handle singular vs. plural "hour(s)"
            return `${diffHours} Hour${diffHours === 1 ? '' : 's'} Ago`;
        }
    }

    const timePassedStr = getTimePassedString();

    const moreThanOneDayPassed = diffHours > 24;

    return (

        <Column fullWidth>

            <Row>
                <Column className="w-6/12" alignItems={"center"}>
                    <TextLabel>Job Listings</TextLabel>
                </Column>
            </Row>


            <Row expand>

                <Column className="w-6/12" alignItems={"center"} expand>
                    <Box width={"100%"} maxWidth={"240px"}>
                        <AdvertsCounters total={total} new={newCount} closed={closed} loading={loading} />
                    </Box>
                </Column>

                <Column className="w-6/12" alignItems={"center"}>
                    <TextLabel>Last Updated</TextLabel>
                    <div className="font-cs">
                        <Skeleton className="rounded-lg" isLoaded={!loading}>
                            <Box className="text-center" mb={1}>{lastUpdated.toLocaleDateString()} {lastUpdated.toLocaleTimeString()}</Box>
                            <Row crossAxisCenter mainAxisCenter>
                                <Chip color={moreThanOneDayPassed ? "danger" : "default"}>
                                    <div className="text-center">{timePassedStr.toUpperCase()}</div>
                                </Chip>
                            </Row>
                        </Skeleton>
                    </div>
                </Column>

            </Row >

        </Column>
    )

}